/**
 * Abertura de chamado (reclamação de objeto) no Fale Conosco dos Correios.
 * Helpers puros — sem React/serviços — para permitir teste unitário.
 */

/** Formulário de reclamação de objeto do Fale Conosco dos Correios. */
export const CORREIOS_COMPLAINT_FORM_URL =
  'https://faleconosco.correios.com.br/cadastro/reclamacao-objeto';

/**
 * URL do formulário de reclamação já com o código do objeto preenchido.
 * O código é normalizado (aparado e em maiúsculas) e escapado — vem do banco
 * ([Shipping].[CorreiosPrepostagem].[CodigoObjeto]) e nunca deve ser concatenado cru.
 */
export const correiosComplaintUrl = (objectCode: string): string =>
  `${CORREIOS_COMPLAINT_FORM_URL}?codigo_objeto=${encodeURIComponent(objectCode.trim().toUpperCase())}`;
